module.exports = __webpack_public_path__ + "static/PlutoSansCondRegular-a8dc51ab175eb4eb5a3f3227c6f4e3d8.woff";